import { Injectable } from '@angular/core'
import { MbConstants } from '../../../shared/mb-constants'
import { CaasIdType } from '../../enums/caas-id-types'
import { map, shareReplay } from 'rxjs/operators'
import { ContactBoxNavigationData } from './contact-box-navigation/contact-box-navigation.module'
import { MbCaasService } from '../../services/mb-caas/mb-caas.service'

const keys = [
  { key: 'page.children.children.name', operator: 1 },
  { key: 'locale.country', operator: 1 },
  { key: 'page.children.children.formData', operator: 1 }
]
@Injectable({ providedIn: 'root' })
export class ContactBoxService {

  constructor (
    private caasService: MbCaasService
  ) {
  }

  contactData$ = this.caasService.getByIds([MbConstants.CONTACT_BOX_FULL], CaasIdType.SEOURL, keys)
    .pipe(
      map((res) => this.mapContactBoxData(res?.[0] ?? {})),
      shareReplay(1))

  getContactData () {
    return this.contactData$
  }

  private mapContactBoxData (data: any): ContactBoxNavigationData {
    const componentData = data.page?.children?.[1]?.children?.[0] ?? {}
    const contactData = componentData.formData?.['st_contact']?.value?.[0]?.formData ?? {}
    const linkTechnicalSupport = componentData.formData?.st_input_link_technical_support?.value?.formData ?? {}
    const linkDistribution = componentData.formData?.st_input_link_distribution?.value?.formData ?? {}
    return {
      linkTechnicalSupport: {
        target: linkTechnicalSupport?.lt_target?.value?.identifier ?? '_self',
        text: linkTechnicalSupport?.lt_text?.value ?? '',
        tooltip: linkTechnicalSupport?.lt_tooltip_text?.value ?? '',
        anchor: linkTechnicalSupport?.lt_anchor?.value ?? '',
        url: linkTechnicalSupport?.lt_page?.value?.uid ?? '',
        uid: 'content_link'
      },
      linkDistribution: {
        target: linkDistribution?.lt_target?.value?.identifier ?? '_self',
        text: linkDistribution?.lt_text?.value ?? '',
        tooltip: linkDistribution?.lt_tooltip_text?.value ?? '',
        anchor: linkDistribution?.lt_anchor?.value ?? '',
        url: linkDistribution?.lt_page?.value?.uid ?? '',
        uid: 'content_link'
      },
      visibility: {
        hide: componentData.formData?.st_hide_component?.value ?? false,
        hideBefore: componentData.formData?.st_hide_before_date?.value ?? '',
        hideAfter: componentData.formData?.st_hide_after_date?.value ?? ''
      },
      previewId: '',
      uid: componentData.name ?? '',
      flexType: componentData.name ?? '',
      contactData: {
        company: contactData.gc_company?.value ?? '',
        country: contactData.gc_country?.value ?? '',
        street: contactData.gc_street?.value ?? '',
        email: contactData.gc_email?.value ?? '',
        fax: contactData.gc_fax?.value ?? '',
        phone: contactData.gc_phone?.value ?? '',
        ordersEmail: contactData.gc_orders_email?.value ?? '',
        ordersFax: contactData.gc_orders_fax?.value ?? '',
        ordersPhone: contactData.gc_orders_phone?.value ?? '',
        cityAndZip: contactData.gc_zip_city?.value ?? '',
        technicalPhone: contactData.gc_technical_phone?.value ?? '',
        technicalSupportChatAvailability: contactData.gc_technical_support_chat_availability?.value ?? '',
        technicalSupportEmail: contactData.gc_technical_support_email?.value ?? '',
        technicalSupportPhoneAvailability: contactData.gc_technical_support_phone_availability?.value ?? '',
        web: contactData.gc_web?.value ?? ''
      }
    }
  }
}
